export default {
    sim_provider_account_delete_title: "Eliminar cuenta de proveedor SIM",
    sim_provider_account_delete_success_message: "Se ha eliminado la cuenta del proveedor de SIM",
    sim_provider_account_delete_error_message: "No es posible borrar la cuenta del proveedor SIM",
    sim_provider_account_delete_confirm_message: "¿Está seguro de que desea eliminar la cuenta del proveedor SIM?",
    sim_provider_account_in_use: "La cuenta del proveedor de sim está vinculada a algunas unidades por lo que no es posible eliminarla",
}